export default "__VITE_ASSET__55f2d388__"